export enum Route {
  ENTRY = '/',
  ERROR = '/error',
  PAYMENT_MODE = '/payment-mode',
  PROCESSING = '/processing',
  SUMMARY = '/summary',
  TILA = '/tila',
}
